import React, { useMemo } from "react";
import { Loading } from "../../../components/loading";
import { useOrders } from "../../orders/hooks";
import { useVisits } from "../../visits/hooks";

interface IProps {
  userId: number;
}

const StatTile: React.FC<{ label: string; value: string }> = ({
  label,
  value,
}) => (
  <div className="flex-1 min-w-[140px] bg-gray-50 rounded p-3">
    <p className="text-xs text-gray-500">{label}</p>
    <p className="text-xl font-semibold text-gray-900">{value}</p>
  </div>
);

export const UserReport: React.FC<IProps> = ({ userId }) => {
  const { data: ordersData, loading: ordersLoading } = useOrders({
    where: { salesRepId: userId },
  });
  const { data: visitsData, loading: visitsLoading } = useVisits({
    where: { salesRepId: userId },
  });

  const orders = ordersData?.orders?.results ?? [];
  const visits = visitsData?.visits?.results ?? [];

  const totalCa = useMemo(
    () => orders.reduce((sum, order) => sum + (order.totalTtcCents ?? 0), 0),
    [orders]
  );

  if (ordersLoading || visitsLoading) return <Loading />;

  if (!orders.length && !visits.length) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-3">
      <StatTile label="Commandes gérées" value={String(orders.length)} />
      <StatTile label="CA apporté TTC" value={`${(totalCa / 100).toFixed(2)} €`} />
      <StatTile label="Visites réalisées" value={String(visits.length)} />
    </div>
  );
};
